import { SolutionOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { TaskType } from 'core/modules/tasks/task.interface';
import { useTranslation } from 'react-i18next';
import { eventStopPropagation } from 'src/utils/button';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var VALID_TYPES = [TaskType.Homologation, TaskType.Recognition];
export var TaskClientTag = function TaskClientTag(_ref) {
  var task = _ref.task;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (!VALID_TYPES.includes(task.content.type)) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var content = task.content;

  if (!content.client) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: "".concat(t('form.task.client.label'), ": ").concat(content.client.name),
      children: /*#__PURE__*/_jsx(Tag, {
        icon: /*#__PURE__*/_jsx(SolutionOutlined, {}),
        onClick: eventStopPropagation,
        children: content.client.name
      })
    }, "client")
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "ClientTag__Container",
  componentId: "sc-16n6f4o-0"
})([".ant-tag{display:block;overflow:hidden;max-width:100px;padding-right:10px;text-overflow:ellipsis;}"]);